import { getState, patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';

type DisplayedColumns = {
    displayedColumns: string[]
}

const initialState: DisplayedColumns = {
    displayedColumns: [],
};

export function withColumnOrdering() {
    return signalStoreFeature(
        withState(initialState),
        withMethods((store) => ({
            updateDisplayedColumns(columns: string[]) {
                const state = getState(store);
                const displayedColumns = state.displayedColumns;
                if (JSON.stringify(displayedColumns) !== JSON.stringify(columns)) {
                    patchState(store, {
                        displayedColumns: [...columns]
                    });
                }
            }

        })),
    );
}